<template>
  <v-form >
    <v-container grid-list-md text-center class="hours-container">
      <v-btn 
        color="red"
        dark
        v-on:click="fetchUsers()">
        <v-img
          v-if="!showSpinner"
          :src="togglIcon"
          max-width="30"
          max-height="30"
        ></v-img>
        <v-progress-circular
          v-if="showSpinner"
          indeterminate
          size=15
          width=2
          color="brown"
        ></v-progress-circular>        
      </v-btn>
      <v-flex mt-4>
        <v-flex xs12  v-if="this.users.length > 0">
          <v-date-picker full-width v-model="picker" type="month" :no-title="true"></v-date-picker>
        </v-flex>
        <v-flex mt-4 xs12>
          <v-btn 
          v-on:click="createAllUsersXLSX()"
          v-if="users.length > 0 && !showCircularCounter"
          class="ma-2" 
          outlined 
          color="green darken-4" 
          >
            Excel All Users
            <v-icon right dark>arrow_drop_down_circle</v-icon>             
          </v-btn>
          <div class="text-center">
            <v-progress-circular
              v-if="showCircularCounter"
              :rotate="-90"
              :size="100"
              :width="5"
              :value="circularCounterValue"
              color="#f29400"
            >
              {{ circularCounterValue }}%
            </v-progress-circular>
          </div>          
        </v-flex>
        <v-select mt-4 xs12
          v-if="users.length > 0"
          :items="users"
          item-text="name"
          item-value="uid"
          label="Individual User Calendar"
          v-model="user"
          v-on:change="changeUser"
        ></v-select>      
      </v-flex>

      <!-- Calendar -->
      <v-flex xs12 class="footerOffset">
        <v-sheet v-if="cal.events.length > 0 && $vuetify.breakpoint.smAndUp" height="64" >
          <v-toolbar flat color="white">
            <v-btn outlined class="mr-4" @click="setToday">
              Today
            </v-btn>
            <v-btn fab text small @click="prev">
              <v-icon small>arrow_back_ios</v-icon>
            </v-btn>
            <v-btn fab text small @click="next">
              <v-icon small>arrow_forward_ios</v-icon>
            </v-btn>
            <v-toolbar-title>{{ cal.title }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-menu bottom right>
              <template v-slot:activator="{ on }">
                <v-btn
                  outlined
                  v-on="on"
                >
                  <span>{{ cal.typeToLabel[cal.type] }}</span>
                  <v-icon right>arrow_drop_down</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="cal.type = 'day'">
                  <v-list-item-title>Day</v-list-item-title>
                </v-list-item>
                <v-list-item @click="cal.type = 'week'">
                  <v-list-item-title>Week</v-list-item-title>
                </v-list-item>
                <v-list-item @click="cal.type = 'month'">
                  <v-list-item-title>Month</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-toolbar>
        </v-sheet>
        <v-sheet v-if="cal.events.length > 0">
          <v-calendar
            ref="calendar"
            color="primary"
            v-model="cal.focus"
            :events="cal.events"
            :event-color="getEventColor"
            :event-margin-bottom="3"
            :type="cal.type"
            @click:event="showEvent"
            @click:more="viewDay"
            @click:date="viewDay"
            @change="updateRange"
          ></v-calendar>
          <v-menu
            v-model="cal.selectedOpen"
            :close-on-content-click="false"
            :activator="cal.selectedElement"
            offset-x
          >
            <v-card
              color="grey lighten-4"
              min-width="350px"
              flat
            >
              <v-toolbar
                :color="cal.selectedEvent.color"
                dark
              >
                <v-toolbar-title v-html="cal.selectedEvent.name"></v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon>
                  <v-icon dark @click="cal.selectedOpen = false">close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text>
                <span v-html="cal.selectedEvent.details"></span>
              </v-card-text>
            </v-card>
          </v-menu>
        </v-sheet>
      </v-flex>
    </v-container>
  </v-form>
</template>

<script>
import UsersApi  from '@/services/UsersApi';
import fnsFormat from 'date-fns/format';
import fnsParse  from 'date-fns/parse';
import fnsAddMonths from 'date-fns/addMonths';
import fnsEndOfDay from 'date-fns/endOfDay';
import fnsLastDayOfMonth from 'date-fns/lastDayOfMonth';
import fnsParseISO from 'date-fns/parseISO';
import fnsEachDayOfInterval from 'date-fns/eachDayOfInterval';
import XLSX from 'xlsx';

export default {
  data () {
    return {
      users:[],
      user: null,
      showSpinner: false,
      showCircularCounter: false,
      circularCounterValue: 0,
      picker: fnsFormat(fnsAddMonths(new Date(),-1),'yyyy-MM'),
      togglIcon: require('@/assets/img/icons/toggl.png'),
      cal: {
        today: fnsFormat(fnsAddMonths(new Date(),-1),'yyyy-MM-dd'),
        focus: fnsFormat(fnsAddMonths(new Date(),-1),'yyyy-MM-dd'),
        type: 'month',
        typeToLabel: {
          month: 'Month',
          week: 'Week',
          day: 'Day'
        },
        start: null,
        end: null,
        selectedEvent: {},
        selectedElement: null,
        selectedOpen: false,
        events: [],
      }
    }
  },
  methods: {
    viewDay ({ date }) {
      this.cal.focus = date
      this.cal.type = 'day'
    },
    getEventColor (event) {
      return event.color
    },
    setToday () {
      this.cal.focus = new Date()
    },
    prev () {
      this.$refs.calendar.prev()
    },
    next () {
      this.$refs.calendar.next()
    },
    showEvent ({ nativeEvent, event }) {
      const open = () => {
        this.cal.selectedEvent = event
        this.cal.selectedElement = nativeEvent.target
        setTimeout(() => this.cal.selectedOpen = true, 10)
      }
      if (this.cal.selectedOpen) {
        this.cal.selectedOpen = false
        setTimeout(open, 10)
      } else {
        open()
      }
      nativeEvent.stopPropagation()
    },
    updateRange ({ start, end }) {
      this.cal.start = start
      this.cal.end = end
    },
    nth (d) {
      return d > 3 && d < 21
        ? 'th'
        : ['th', 'st', 'nd', 'rd', 'th', 'th', 'th', 'th', 'th', 'th'][d % 10]
    },
    async fetchUsers(){
      this.showSpinner=true
      const response = await UsersApi.getTogglUsers()
      this.users = response.data.data
      this.showSpinner=false
    },
    async userDataToCal(userData){
      let events = []
      Object.keys(userData).forEach((key)=> {
        this.createEvent(events, userData[key].std, 'green lighten-2');
        this.createEvent(events, userData[key].std15, 'yellow darken-2');
        this.createEvent(events, userData[key].std175, 'yellow darken-3');
        this.createEvent(events, userData[key].std2, 'orange darken-4');
        this.createEvent(events, userData[key].phols, 'indigo');
        this.createEvent(events, userData[key].leave, 'grey darken-1');
        this.createEvent(events, userData[key].sick, 'red darken-1');
      });
      return events;
    },    
    async changeUser(){
      let ud = this.users.filter(u => u.uid === this.user)[0];
      let userData = await this.fetchUserData(ud);
      let calData = await this.userDataToCal(userData);
      this.cal.events = calData;
      this.cal.title = ud.name;
      this.cal.focus = this.picker + '-01';
    },
    async fetchUserData(ud) {
      let since = fnsParse(this.picker, 'yyyy-MM', new Date());
      let until = fnsEndOfDay(fnsLastDayOfMonth(since));
      const response = await UsersApi.getTogglUserData({
        userDetail: ud, 
        since: since,
        until: until 
      })
      return response.data.userData;
    },
    roundToTwo(num) {
      return +(Math.round(num + "e+2")  + "e-2");
    },    
    createEvent(events, obj, color) {
      if(obj.m > 0){
        events.push({
          name: obj.p,
          details: obj.h + ' hours </br>'
                + 'From: '+ fnsFormat(fnsParseISO(obj.min), 'yy/MM HH:mm') +'</br>'
                + 'To  : '+ fnsFormat(fnsParseISO(obj.max), 'yy/MM HH:mm') +'</br>'
                + obj.d,
          start: fnsFormat(fnsParseISO(obj.min), 'yyyy-MM-dd HH:mm'),
          end: fnsFormat(fnsParseISO(obj.max), 'yyyy-MM-dd HH:mm'),
          color: color,
        });
      }
    },
    async userDataToSheet(userData){
      let std = Object.keys(userData).map(function(key) {return userData[key].std.h;});
      let std15 = Object.keys(userData).map(function(key) {return userData[key].std15.h;});
      let std175 = Object.keys(userData).map(function(key) {return userData[key].std175.h;});
      let std2 = Object.keys(userData).map(function(key) {return userData[key].std2.h;});
      let phols = Object.keys(userData).map(function(key) {return userData[key].phols.h;});
      let leave = Object.keys(userData).map(function(key) {return userData[key].leave.h;});
      let sick = Object.keys(userData).map(function(key) {return userData[key].sick.h;});
      let compassionate = Object.keys(userData).map(function(key) {return userData[key].compassionate.h;});
      let total = [];
      for (let i = 0; i < std.length; i++) {
        let t = std[i] + std15[i] + std175[i] + std2[i] + phols[i] + leave[i] + sick[i] + compassionate[i];
        total.push(t)
      }
      return [[], std, std15, std175, std2, phols, leave, sick, compassionate, total];
    },    
    async createAllUsersXLSX(){
      this.showCircularCounter = true;
      let since = fnsParse(this.picker, 'yyyy-MM', new Date());
      let until = fnsEndOfDay(fnsLastDayOfMonth(since));
      var wb = XLSX.utils.book_new();
      wb.Props = {
        Title: fnsFormat(since,'MMM') +" Pay Run",
        Subject: "Pay Run",
        Author: "ThinkSpatial",
        CreatedDate: new Date()
      };
      let ws_data1 = [];
      let ws_data2 = [];
      wb.SheetNames.push(fnsFormat(since,'MMMM')+ " Summary");
      let firstRow1=['Name','SR Hours','SR*1.5 Hours', 'SR*1.75 Hours', 'SR*2 Hours', 'P/Holidays Hours', 'Leave Hours', 'Sick Hours', 'Compassionate Hours']

      wb.SheetNames.push(fnsFormat(since,'MMMM')+ " Detail");

      let firstRow2 = [];
      let secondRow2 = [];
      let days = fnsEachDayOfInterval({
        start: since,
        end: until
      })
      for(let day of days) {
        firstRow2.push(fnsFormat(day,'dd/MM'));
        secondRow2.push(fnsFormat(day,'dd'))
      }
      firstRow2.unshift(''); 
      secondRow2.unshift(''); 
      ws_data1.push(firstRow1);
      ws_data2.push(firstRow2);
      ws_data2.push(secondRow2);
      let userCount = 0;
      for(let user of this.users) {
        userCount += 1;
        let value = this.roundToTwo(userCount/this.users.length)*100;
        this.circularCounterValue = value.toFixed(0);
        let userdata = await this.fetchUserData(user);
        let sheet = await this.userDataToSheet(userdata);
        let ws1_item = [];
        ws1_item.push(user.name);
        ws1_item.push(this.roundToTwo(sheet[1].reduce((a, b) => a + b, 0)));
        ws1_item.push(this.roundToTwo(sheet[2].reduce((a, b) => a + b, 0)));
        ws1_item.push(this.roundToTwo(sheet[3].reduce((a, b) => a + b, 0)));
        ws1_item.push(this.roundToTwo(sheet[4].reduce((a, b) => a + b, 0)));
        ws1_item.push(this.roundToTwo(sheet[5].reduce((a, b) => a + b, 0)));
        ws1_item.push(this.roundToTwo(sheet[6].reduce((a, b) => a + b, 0)));
        ws1_item.push(this.roundToTwo(sheet[7].reduce((a, b) => a + b, 0)));
        ws1_item.push(this.roundToTwo(sheet[8].reduce((a, b) => a + b, 0)));
        ws_data1.push(ws1_item); 

        sheet.forEach((item, index) => {
          switch(index) {
            case 9:
              item.unshift(user.name.toUpperCase() +' TOTAL');
              break;
            case 8:
              item.unshift(user.name +' Compassionate');
              break;                          
            case 7:
              item.unshift(user.name+' Sick');
              break;             
            case 6:
              item.unshift(user.name+' Leave');
              break;             
            case 5:
              item.unshift(user.name+' Public Holidays');
              break;            
            case 4:
              item.unshift(user.name+' SR * 2');
              break;
            case 3:
              item.unshift(user.name+' SR * 1.75');
              break;
            case 2:
              item.unshift(user.name+' SR * 1.5');
              break;
            case 1:
              item.unshift(user.name+' SR');
              break;                           
            default:
              item.unshift('');
          }
          ws_data2.push(item);
        });
      }
      let ws1 = XLSX.utils.aoa_to_sheet(ws_data1);
      let ws2 = XLSX.utils.aoa_to_sheet(ws_data2);
      let wscols1 = [{wch:40},{wch:15},{wch:15},{wch:15},{wch:15},{wch:15},{wch:15}, {wch:15}, {wch:15}];
      let wscols2 =[];
      for (let i = 0; i < firstRow2.length; i++) {
        if(i===0) { 
          wscols2.push({wch:40})
        } else {
          wscols2.push({wch:5})
        }
      }
      ws1['!cols'] = wscols1;
      ws2['!cols'] = wscols2;
      wb.Sheets[fnsFormat(since,'MMMM')+ " Summary"] = ws1;
      wb.Sheets[fnsFormat(since,'MMMM')+ " Detail"] = ws2;
      this.showCircularCounter = false;
      XLSX.writeFile(wb, fnsFormat(since,'yyMM')+'.xlsx'); 
    }
  }
}
</script>

<style scoped>
  .hours-container{
    width: 80%;
    margin: 0 auto;
    padding: 20px;
  }

  .footerOffset{
    margin-bottom:66px;
  }
</style>